export { createPageContextClientSide };
import { createPageContextObject, createPageContextShared } from '../../shared/createPageContextShared.js';
import { getPageContextUrlComputed } from '../../shared/getPageContextUrlComputed.js';
import { getBaseServer } from './getBaseServer.js';
import { getGlobalContextClientInternal } from './globalContext.js';
import { assert, augmentType, isBaseServer, objectAssign } from './utils.js';
async function createPageContextClientSide(urlOriginal) {
    const globalContext = await getGlobalContextClientInternal();
    const baseServer = getBaseServer();
    assert(isBaseServer(baseServer));
    const pageContextCreated = createPageContextObject();
    objectAssign(pageContextCreated, {
        isClientSide: true,
        isPrerendering: false,
        urlOriginal,
        _globalContext: globalContext,
        _pageFilesAll: globalContext._pageFilesAll,
        _pageConfigs: globalContext._pageConfigs,
        _pageConfigGlobal: globalContext._pageConfigGlobal,
        _allPageIds: globalContext._allPageIds,
        _pageRoutes: globalContext._pageRoutes,
        _onBeforeRouteHook: globalContext._onBeforeRouteHook,
        _urlHandler: null,
        _urlRewrite: null,
        _baseServer: baseServer
    });
    const pageContextUrlComputed = getPageContextUrlComputed(pageContextCreated);
    objectAssign(pageContextCreated, pageContextUrlComputed);
    const pageContextAugmented = await createPageContextShared(pageContextCreated, globalContext._pageConfigGlobal, globalContext._userFriendlyConfigsGlobal);
    augmentType(pageContextCreated, pageContextAugmented);
    return pageContextCreated;
}
